import { charSequenceLength3278n89t01tmv as charSequenceLength } from '../../../../kotlin-kotlin-stdlib/kotlin/js/charSequenceJs.mjs';
import {
  joinToString1cxrrlmo0chqs as joinToString,
  lastOrNull1aq5oz189qoe1 as lastOrNull,
} from '../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { Unit_instancev9v8hjid95df as Unit_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import { EmptySerializersModule991ju6pz9b79 as EmptySerializersModule } from '../modules/SerializersModuleBuilders.mjs';
import { SerializationExceptioneqrdve3ts2n9 as SerializationException } from '../SerializationExceptions.mjs';
import { getKClassFromExpression348iqjl4fnx2f as getKClassFromExpression } from '../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/reflection.mjs';
import {
  toString1pkumu07cwy4m as toString,
  protoOf180f3jzyo7rfj as protoOf,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { Char19o2r8palgjof as Char } from '../../../../kotlin-kotlin-stdlib/kotlin/Char.mjs';
import {
  decodeSerializableElement$default1kkisaow5bg5n as decodeSerializableElement$default,
  decodeSerializableValue3h7ajfesxzjda as decodeSerializableValue,
  decodeSequentially27kmi8jnnsnbc as decodeSequentially,
  decodeCollectionSize3l4gjp9ef5h8u as decodeCollectionSize,
  Decoder23nde051s631g as Decoder,
  CompositeDecoder2tzm7wpwkr0og as CompositeDecoder,
} from '../encoding/Decoding.mjs';
import { get_lastIndex1yw0x4k50k51w as get_lastIndex } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/CollectionsKt.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var NamedValueDecoderClass;
function NamedValueDecoder() {
  if (NamedValueDecoderClass === VOID) {
    class $ extends TaggedDecoder() {
      s25(_this__u8e3s4, index) {
        return this.u25(this.t25(_this__u8e3s4, index));
      }
      u25(nestedName) {
        var tmp0_elvis_lhs = this.x25();
        return this.y25(tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs, nestedName);
      }
      t25(descriptor, index) {
        return descriptor.s1p(index);
      }
      y25(parentName, childName) {
        var tmp;
        // Inline function 'kotlin.text.isEmpty' call
        if (charSequenceLength(parentName) === 0) {
          tmp = childName;
        } else {
          tmp = parentName + '.' + childName;
        }
        return tmp;
      }
      z25() {
        return this.v25_1.n1() ? '$' : joinToString(this.v25_1, '.', '$.');
      }
    }
    initMetadataForClass($, 'NamedValueDecoder');
    NamedValueDecoderClass = $;
  }
  return NamedValueDecoderClass;
}
function tagBlock($this, tag, block) {
  $this.n26(tag);
  var r = block();
  if (!$this.w25_1) {
    $this.o26();
  }
  $this.w25_1 = false;
  return r;
}
var TaggedDecoderClass;
function TaggedDecoder() {
  if (TaggedDecoderClass === VOID) {
    class $ {
      constructor() {
        var tmp = this;
        // Inline function 'kotlin.collections.arrayListOf' call
        tmp.v25_1 = ArrayList().p2();
        this.w25_1 = false;
      }
      y1r() {
        return EmptySerializersModule();
      }
      a26(tag) {
        throw SerializationException().n1o(toString(getKClassFromExpression(this)) + " can't retrieve untyped values");
      }
      b26(tag) {
        return true;
      }
      c26(tag) {
        var tmp = this.a26(tag);
        return typeof tmp === 'boolean' ? tmp : THROW_CCE();
      }
      d26(tag) {
        var tmp = this.a26(tag);
        return typeof tmp === 'number' ? tmp : THROW_CCE();
      }
      e26(tag) {
        var tmp = this.a26(tag);
        return typeof tmp === 'number' ? tmp : THROW_CCE();
      }
      f26(tag) {
        var tmp = this.a26(tag);
        return typeof tmp === 'number' ? tmp : THROW_CCE();
      }
      g26(tag) {
        var tmp = this.a26(tag);
        return typeof tmp === 'bigint' ? tmp : THROW_CCE();
      }
      h26(tag) {
        var tmp = this.a26(tag);
        return typeof tmp === 'number' ? tmp : THROW_CCE();
      }
      i26(tag) {
        var tmp = this.a26(tag);
        return typeof tmp === 'number' ? tmp : THROW_CCE();
      }
      j26(tag) {
        var tmp = this.a26(tag);
        return tmp instanceof Char() ? tmp.e4_1 : THROW_CCE();
      }
      k26(tag) {
        var tmp = this.a26(tag);
        return typeof tmp === 'string' ? tmp : THROW_CCE();
      }
      l26(tag, enumDescriptor) {
        var tmp = this.a26(tag);
        return typeof tmp === 'number' ? tmp : THROW_CCE();
      }
      m26(tag, inlineDescriptor) {
        // Inline function 'kotlin.apply' call
        this.n26(tag);
        return this;
      }
      h1r(deserializer, previousValue) {
        return this.i1r(deserializer);
      }
      g1r(descriptor) {
        return this.m26(this.o26(), descriptor);
      }
      u1q() {
        var tmp0_elvis_lhs = this.x25();
        var tmp;
        if (tmp0_elvis_lhs == null) {
          return false;
        } else {
          tmp = tmp0_elvis_lhs;
        }
        var currentTag = tmp;
        return this.b26(currentTag);
      }
      v1q() {
        return null;
      }
      w1q() {
        return this.c26(this.o26());
      }
      x1q() {
        return this.d26(this.o26());
      }
      y1q() {
        return this.e26(this.o26());
      }
      z1q() {
        return this.f26(this.o26());
      }
      a1r() {
        return this.g26(this.o26());
      }
      b1r() {
        return this.h26(this.o26());
      }
      c1r() {
        return this.i26(this.o26());
      }
      d1r() {
        return this.j26(this.o26());
      }
      e1r() {
        return this.k26(this.o26());
      }
      f1r(enumDescriptor) {
        return this.l26(this.o26(), enumDescriptor);
      }
      j1r(descriptor) {
        return this;
      }
      k1r(descriptor) {
      }
      l1r(descriptor, index) {
        return this.c26(this.s25(descriptor, index));
      }
      m1r(descriptor, index) {
        return this.d26(this.s25(descriptor, index));
      }
      n1r(descriptor, index) {
        return this.e26(this.s25(descriptor, index));
      }
      o1r(descriptor, index) {
        return this.f26(this.s25(descriptor, index));
      }
      p1r(descriptor, index) {
        return this.g26(this.s25(descriptor, index));
      }
      q1r(descriptor, index) {
        return this.h26(this.s25(descriptor, index));
      }
      r1r(descriptor, index) {
        return this.i26(this.s25(descriptor, index));
      }
      s1r(descriptor, index) {
        return this.j26(this.s25(descriptor, index));
      }
      t1r(descriptor, index) {
        return this.k26(this.s25(descriptor, index));
      }
      u1r(descriptor, index) {
        return this.m26(this.s25(descriptor, index), descriptor.v1p(index));
      }
      v1r(descriptor, index, deserializer, previousValue) {
        var tmp = this.s25(descriptor, index);
        return tagBlock(this, tmp, () => this.h1r(deserializer, previousValue));
      }
      x1r(descriptor, index, deserializer, previousValue) {
        var tmp = this.s25(descriptor, index);
        return tagBlock(this, tmp, () => {
          // Inline function 'kotlinx.serialization.encoding.decodeIfNullable' call
          var isNullabilitySupported = deserializer.s1m().h1p();
          var tmp;
          if (isNullabilitySupported || this.u1q()) {
            tmp = this.h1r(deserializer, previousValue);
          } else {
            tmp = this.v1q();
          }
          return tmp;
        });
      }
      x25() {
        return lastOrNull(this.v25_1);
      }
      n26(name) {
        this.v25_1.i2(name);
      }
      o26() {
        var r = this.v25_1.c5(get_lastIndex(this.v25_1));
        this.w25_1 = true;
        return r;
      }
    }
    protoOf($).w1r = decodeSerializableElement$default;
    protoOf($).i1r = decodeSerializableValue;
    protoOf($).z1r = decodeSequentially;
    protoOf($).b1s = decodeCollectionSize;
    initMetadataForClass($, 'TaggedDecoder', VOID, VOID, [Decoder(), CompositeDecoder()]);
    TaggedDecoderClass = $;
  }
  return TaggedDecoderClass;
}
//region block: exports
export {
  NamedValueDecoder as NamedValueDecoderzk26ztf92xbq,
};
//endregion

//# sourceMappingURL=Tagged.mjs.map
